import { getDownloadURL } from 'firebase/storage';
import { createStorageRef } from './helpers';

export default function getDownloadURLFactory(storage) {
  return function getDownloadURLFunction(path) {
    return getDownloadURL(createStorageRef(storage, path));
  };
}
